import { ShiftsCompanyHolidayFragment, ShiftsLocationFragment } from 'generated/resources/graphql'
import { computed, makeObservable } from 'mobx'
import type moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

import locationCollection from 'modules/locations/store/collections/locations'
import type Location from 'modules/locations/store/models/Location'

export interface Props {
  id: string
  date: string
  half_day: string
  summary: string
  description: string
  location_id: string
}

class Holiday {
  id: string
  date: moment.Moment
  halfDay: string
  summary: string
  description: string
  locationId: string

  constructor(props: Props) {
    this.id = props.id
    this.date = stringToDate(props.date, 'backend')
    this.halfDay = props.half_day
    this.summary = props.summary
    this.description = props.description
    this.locationId = props.location_id

    makeObservable(this, {
      location: computed,
    })
  }

  static buildFromGraphQL(
    fragment: ShiftsCompanyHolidayFragment,
    location: ShiftsLocationFragment | undefined | null
  ): Holiday {
    return new Holiday({
      id: fragment.id,
      date: fragment.date,
      half_day: fragment.halfDay || '',
      summary: fragment.summary || '',
      description: fragment.description || '',
      // FIXME: Improve this to avoid location or use the fragment.
      location_id: location?.id ?? '0',
    })
  }

  get location(): Location | undefined {
    return locationCollection.find({
      id: this.locationId,
    })
  }

  isDate(date: moment.Moment): boolean {
    return this.date.isSame(date, 'day')
  }
}

export default Holiday
